import { render } from "./IconCamera.vue?vue&type=template&id=2dfba293"
import script from "./IconCamera.vue?vue&type=script&lang=ts"
export * from "./IconCamera.vue?vue&type=script&lang=ts"
script.render = render

export default script